import { render, staticRenderFns } from "./LocationProduct.vue?vue&type=template&id=fd156bfc&scoped=true"
import script from "./LocationProduct.vue?vue&type=script&lang=js"
export * from "./LocationProduct.vue?vue&type=script&lang=js"
import style0 from "./LocationProduct.vue?vue&type=style&index=0&id=fd156bfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd156bfc",
  null
  
)

export default component.exports